import { RootState } from '../store';
import { transactionBacklogState } from './transactionBacklog.reducer';

export const getTransactionBacklog = (
  state: RootState,
): transactionBacklogState => state.transactionBacklog;

export const isTransactionBacklogEmpty = (state: RootState): boolean =>
  getTransactionBacklog(state).length === 0;
